import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    TemplateRef,
    ViewChild,
} from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthUserService, StoreSelectorsService, StyleService } from "app/services";
import { LoginForm } from "app/models";
import { animate, keyframes, state, style, transition, trigger } from "@angular/animations";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import {
    actionAccountCommandsFailure,
    actionAccountCommandsRequest,
    actionAccountSocialLoginRequest,
    actionAppSettings,
    actionCreateCredentialsLdapReply,
    actionDynawebsCheckUser,
    actionDynawebsCheckUserSuccess,
    actionLoginViewMode,
    actionPlaySweepLine,
} from "../../../store/actions/user.actions";
import { FacebookLoginProvider, SocialUser } from "@abacritt/angularx-social-login";
import { faAmazon, faFacebook, faGoogle } from "@fortawesome/free-brands-svg-icons";
import {
    faCloudDownloadAlt,
    faCog,
    faEnvelope,
    faHome,
    faQuestionCircle,
    faServer,
    faShoppingCart,
    faSignInAlt,
    faTag,
    faTh,
    faUser,
    faWrench,
} from "@fortawesome/free-solid-svg-icons";
import {
    avoidPassCharacters,
    base64ToJson,
    convertBooleanToNumbers,
    convertNumberToBoolean,
    DEFAULT_PROTOCOL,
    DEFAULT_RESELLER_ID,
    DEFAULT_SERVER,
    isHostDevOrLocal,
    isHostLocal,
    isNullOrUndefOrEmpty,
    PREVIOUSLY_USED_ACCOUNT,
    sampleGoogleUser,
    validateEmail,
} from "../../../common";
import { EnumLoginViewMode, EnumStudioType, IAppStatic, IPreloadResellerInfo, loginUrlType } from "../../../interfaces";
import { TranslocoService } from "@ngneat/transloco";
import { LocalStoreService } from "app/services/local-store.service";
import { faKey } from "@fortawesome/free-solid-svg-icons/faKey";
import { ActionsSubject } from "@ngrx/store";
import { ofType } from "@ngrx/effects";
import { AppService } from "../../../services";
import { Compbaser } from "../../../components/compbaser";
import { Lib } from "../../../../libs/Lib";
import * as _ from "lodash";

const { version: appVersion } = require("../../../../../package.json");

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    animations: [
        trigger("fadeIn", [
            transition("void => *", [
                style({ opacity: 0 }),
                animate(2000, style({ opacity: 1 })),
            ]),
        ]),
        trigger("inOutAnimation", [
            transition(":enter", [
                style({ height: 0, opacity: 0 }),
                animate("1.5s ease-out", style({ height: 300, opacity: 1 })),
            ]),
            transition(":leave", [
                style({ height: 300, opacity: 1 }),
                animate("1.5s ease-in", style({ height: 0, opacity: 0 })),
            ]),
        ]),
        trigger("loginState", [
            state("inactive", style({
                backgroundColor: "red",
                transform: "scale(1)",
                opacity: 0,
            })),
            state("default", style({
                transform: "scale(1)",
                opacity: 0.9,
            })),
            // ,
            // state('active', style({
            //     opacity: 1,
            //     transform: 'scale(0.98)'
            // })),
            // transition('* => active', animate('600ms ease-out')),
            // transition('* => inactive', animate('2000ms ease-out'))
        ]),
        trigger("showTwoFactor", [
            state("true", style({
                transform: "scale(1)",
            })),
            transition(":enter", [
                animate("1s 2s cubic-bezier(0.455,0.03,0.515,0.955)", keyframes([
                    style({
                        opacity: 0,
                        transform: "translateX(-400px)",
                    }),
                    style({
                        opacity: 1,
                        transform: "translateX(0)",
                    }),
                ])),
            ]),
            transition(":leave", animate("500ms cubic-bezier(.17,.67,.83,.67)")),
        ]),
    ],
    standalone: false
})
export class LoginComponent extends Compbaser implements OnInit, OnDestroy {
    socialUser: SocialUser;
    disabledLoginInputs = false;
    showSweepLine = true;
    selectedLoginMode = "loginWithEmail";
    selectedOptions = "";
    showGoogleLogin = false;
    appVersion = appVersion;
    faFacebook = faFacebook;
    faEnvelope = faEnvelope;
    faShoppingCart = faShoppingCart;
    faUser = faUser;
    faAmazon = faAmazon;
    faCog = faCog;
    faServer = faServer;
    faKey = faKey;
    faCloudDownloadAlt = faCloudDownloadAlt;
    faWrench = faWrench;
    faTh = faTh;
    faTag = faTag;
    faQuestionCircle = faQuestionCircle;
    faHome = faHome;
    faSignInAlt = faSignInAlt;
    faGoogle = faGoogle;
    form: FormGroup;
    model: LoginForm = new LoginForm();
    m_viewMod = EnumLoginViewMode;
    m_currentViewMode: EnumLoginViewMode;
    m_mode: loginUrlType;
    m_modeUrlParam: loginUrlType;
    amazonOptions: any = {};
    privateServer = "";
    ldapServer = "";
    appSettings: IAppStatic;
    isDev = isHostDevOrLocal();
    useDevServerPort = false;
    isFullFeatures;
    isWhiteLabeled = false;
    preLoginResellerInfo: IPreloadResellerInfo;
    showCreateAccount = true;
    stylesObj = {
        img: {
            "width": "86px",
            "height": "50px",
        },
    };
    public m_user = "";
    public m_pass = "";
    public m_passRepeat = "";
    public m_rememberMe = true;
    public loginState = "";
    public focusedField = "";

    @ViewChild("privatesModal", { read: TemplateRef }) privatesModal: TemplateRef<any>;

    // @ViewChild('userLogin', {static: false}) userLogin: ElementRef;
    @ViewChild("userPass", { static: false }) userPass: ElementRef;
    @ViewChild("userPass2", { static: false }) userPass2: ElementRef;

    @Input()
    set setMode(i_mode: loginUrlType) {
        this.m_mode = i_mode;
    }

    @Output()
    createAccountEvent = new EventEmitter<LoginForm>();

    constructor(
        // private el: ElementRef,
        private translocoService: TranslocoService,
        private storeSelector: StoreSelectorsService,
        public router: Router,
        private route: ActivatedRoute,
        private actionsSubj: ActionsSubject,
        private formBuilder: FormBuilder,
        private authUserService: AuthUserService,
        private appService: AppService,
        private styleService: StyleService,
        private toastr: ToastrService,
        private localStoreService: LocalStoreService,
        public override dialog?: MatDialog,
    ) {
        super(dialog);
        console.log("> loaded version " + appVersion);
        this.amazonOptions["scope"] = "profile";
        this.initPreloginResellerInfo();
        if (isHostLocal()) {
            this.m_user = "car00@ms.com";
            this.m_pass = "123123";
        }
        // this.amazonOptions['pkce'] = true; // SDK generates a `code_verifier` and `code_challenge`
        // styleService.addStyle('loginStyle', require('./style.scss'));
        this.cod(
            this.storeSelector.getResellerId(this.localStoreService)
                .subscribe((i_resellerId: number) => {
                    if (i_resellerId === DEFAULT_RESELLER_ID) {
                    } else {
                        this.isWhiteLabeled = true;
                    }
                }),
        );
        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            }),
        );
        this.cod(
            this.storeSelector.getLocalStoreUpdates().subscribe((v) => {
                this.ldapServer = this.localStoreService.getStorageConfig().ldapServer;
                this.privateServer = this.localStoreService.getStorageConfig().privateServer;
                // OFF by default — checked ONLY when explicitly '1' (matches getInitialDevPort() and
                // user-settings; default port is now prod 443, dev 9443 only when opted in).
                this.useDevServerPort = convertNumberToBoolean(this.localStoreService.getStorageValConfig('useDevServerPort'));
            }),
        );
        this.cod(
            storeSelector.getLoginViewMode()
                .subscribe((loginViewMode) => {
                    this.m_currentViewMode = loginViewMode;
                }),
        );
        this.cod(
            storeSelector.getAppSettings()
                .subscribe((appSettings: IAppStatic) => {
                    this.appSettings = appSettings;
                }),
        );
        this.cod(
            this.route.queryParams.subscribe((queryParams) => {
                if (queryParams.private)
                    this.onUpdatePrivatesStore("privateServer", queryParams.private);
                if (queryParams.ldap)
                    this.onUpdatePrivatesStore("ldapServer", queryParams.ldap);
                if (queryParams.autologin) {
                    this.signInAutoLogin(queryParams);
                }
            }),
        );
        this.cod(
            this.route.paramMap.subscribe((routeParams) => {
                const id = routeParams.get("id");
                this.m_modeUrlParam = routeParams.get("mode") as loginUrlType;
                if (this.router.url && this.router.url.toLowerCase().indexOf("amazonverified") > -1) {
                    this.signInWithAmazon(id);
                }
            }),
        );
        this.cod(
            actionsSubj.pipe(ofType(actionPlaySweepLine))
                .subscribe(() => {
                    this.showSweepLine = false;
                    setTimeout(() => this.showSweepLine = true, 50);
                }),
        );
        this.cod(
            actionsSubj.pipe(ofType(actionAccountCommandsFailure))
                .subscribe((reply) => {
                    this.storeSelector.dispatch(actionLoginViewMode({ loginViewMode: EnumLoginViewMode.LOGIN }));
                    console.log("connection error " + reply.errorMessage);
                    return this.toastr.error(this.translocoService.translate("toast.cannotComplete", {}, this.translocoService.getActiveLang()));
                }),
        );
        this.cod(
            actionsSubj.pipe(ofType(actionDynawebsCheckUserSuccess))
                .subscribe((reply) => {
                    if (reply.payload.businessId !== -1) {
                        this.m_user = "";
                        return this.toastr.warning(this.translocoService.translate("general.userExists", {}, this.translocoService.getActiveLang()));
                    }
                }),
        );
        this.cod(
            actionsSubj.pipe(ofType(actionCreateCredentialsLdapReply))
                .subscribe((reply) => {
                    const i_socialUser: SocialUser = new SocialUser();
                    reply.accountReply.ldap.userPassword = Lib.CleanCharForXml(reply.accountReply.ldap.userPassword).replace(/\s/g, "").replace(/=/g, "");
                    i_socialUser.provider = "LDAP";
                    i_socialUser.id = reply.accountReply.ldap.uid;
                    i_socialUser.email = reply.accountReply.ldap.mail;
                    i_socialUser.name = reply.accountReply.ldap.cn;
                    i_socialUser.authToken = reply.accountReply.ldap as any;
                    i_socialUser.idToken = reply.accountReply.ldap.userPassword;
                    i_socialUser.photoUrl = "http://www.www.jpg";
                    i_socialUser.firstName = "";
                    i_socialUser.lastName = "";
                    this.verifyToken(i_socialUser);
                }),
        );
    }

    setViewMode(v: EnumLoginViewMode) {
        this.storeSelector.dispatch(actionLoginViewMode({ loginViewMode: v }));
    }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            username: [this.model.username, [Validators.required]],
            password: [this.model.password, [Validators.required]],
        });

        if (!this.authUserService.getSocialAuthState$()) {
        }
        this.cod(
            this.authUserService.getSocialAuthState$()
                .subscribe((i_socialUser) => {
                    this.socialUser = i_socialUser;
                }),
        );

        this.cod(
            this.authUserService.getSocialAuthState$().subscribe((i_user) => {
                this.googleLoginContinue(i_user);
            }),
        );
        // setTimeout(() => {
        // this.userLogin.nativeElement.focus();
        // }, 2000);
    }

    googleLoginContinue(socialUser: SocialUser) {
        if (socialUser.provider !== "GOOGLE") return;
        // console.log('login via google ' + JSON.stringify(socialUser));
        this.verifyToken(socialUser);
    }

    onLoginWith(name, e: MouseEvent) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.localStoreService.setStorageValConfig("accountInitialCopyResources", PREVIOUSLY_USED_ACCOUNT);
        this.selectedLoginMode = name;
        switch (this.selectedLoginMode) {
            case "loginWithPrivates": {
                this.disabledLoginInputs = false;
                break;
            }
            case "loginWithEmail": {
                this.disabledLoginInputs = false;
                break;
            }
            case "loginWithGL": {
                this.showGoogleLogin = true;
                // simulate login for tests
                if (isHostLocal()) {
                    this.googleLoginContinue(sampleGoogleUser);
                }
                break;
            }
            case "loginWithBiometrics":
            case "continueAsGuest":
            case "loginWithAmazon":
            case "loginWithFB": {
                this.showGoogleLogin = false;
                this.disabledLoginInputs = true;
                break;
            }
        }
    }

    /** if user is under a reseller, i.e.: login?ent=xxxx pass in we use white label for preloading branding support **/
    initPreloginResellerInfo() {
        this.cod(
            this.storeSelector.getPreloginResellerInfo()
                .subscribe((i_preLoginResellerInfo) => {
                    this.preLoginResellerInfo = i_preLoginResellerInfo;
                    this.showCreateAccount = convertNumberToBoolean(this.preLoginResellerInfo.custom_studio_json.Application[0]?.CreateAccount?.[0]?.$?.show);
                }),
        );
        this.cod(
            this.route.queryParams
                .subscribe((routeParams) => {
                    const resellerEncId = routeParams?.ent;
                    if (isNullOrUndefOrEmpty(resellerEncId) || resellerEncId.length < 8) return;
                    this.showGoogleLogin = false;
                    let resellerId;
                    try {
                        resellerId = Lib.RC4Decrypt(resellerEncId);
                        this.showCreateAccount = false;
                    } catch (e) {
                        resellerId = DEFAULT_RESELLER_ID;
                    }
                    this.localStoreService.setPreloginReseller(resellerId);
                    // this.storeSelector.dispatch(actionPreloginResellerRequest({resellerId}));
                }),
        );
    }

    onShowOptions(name, e: MouseEvent) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (name === "home") {
            this.selectedOptions = "home";
            this.onOpenHomePage();
            return;
        }
        if (this.selectedOptions === "settings")
            return this.selectedOptions = "";
        this.selectedOptions = name;
    }

    onOpenHomePage() {
        this.appService.goToHomePage(false);
    }

    signInGuest(e: Event): void {
        alert("guest");
    }

    /** emails are always lower case, but username are case-sensitive **/
    fixUserCase(i_user: string) {
        return validateEmail(i_user) ? i_user.toLowerCase().trim() : i_user.trim();
    }

    createAccount(event) {
        this.toastr.clear();
        if (this.m_pass !== this.m_passRepeat) return this.toastr.error(this.translocoService.translate("account.passwordMismatch", {}, this.translocoService.getActiveLang()));
        if (this.m_user.length < 3) return this.toastr.error(this.translocoService.translate("account.emailMoreChar", {}, this.translocoService.getActiveLang()));
        if (this.m_pass.length < 3) return this.toastr.error(this.translocoService.translate("account.origPassTooShort", {}, this.translocoService.getActiveLang()));
        if (this.m_pass.match(/,/)?.length > 0 || this.m_pass.match(/#/)?.length > 0) {
            return this.toastr.error(this.translocoService.translate("account.useSimpleCharactersForPassword", {}, this.translocoService.getActiveLang()));
        }


        if (!validateEmail(this.m_user)) return this.toastr.error(this.translocoService.translate("toast.pleaseProvideValidEmail", {}, this.translocoService.getActiveLang()));
        this.m_user = this.fixUserCase(this.m_user);
        const loginForm = new LoginForm();
        this.localStoreService.setStorageValConfig("accountInitialCopyResources", "");
        loginForm.username = this.m_user;
        loginForm.password = this.m_pass;
        this.createAccountEvent.emit(loginForm);
    }

    signInWithEmail(): void {
        if (this.m_user.length < 3 || this.m_pass.length < 3) {
            this.toastr.info(this.translocoService.translate("account.loginTooShort", {}, this.translocoService.getActiveLang()));
            return;
        }
        this.animateLogin();
        this.localStoreService.setStorageValConfig("accountInitialCopyResources", PREVIOUSLY_USED_ACCOUNT);
        if (this.checkIfSigningPrivateServer()) this.toastr.info(this.translocoService.translate("account.loginWithPrivate", {}, this.translocoService.getActiveLang()));
        if (this.checkIfSigningLdapServer()) return;
        this.model.username = this.fixUserCase(this.m_user);
        this.model.password = this.m_pass;
        this.authUserService.login(this.model, this.m_rememberMe);
    }

    unAnimateLogin() {
        this.toastr.clear();
        this.storeSelector.dispatch(actionLoginViewMode({ loginViewMode: EnumLoginViewMode.LOGIN }));
    }

    animateLogin() {
        this.toastr.clear();
        this.storeSelector.dispatch(actionPlaySweepLine());
        this.storeSelector.dispatch(actionLoginViewMode({ loginViewMode: EnumLoginViewMode.LOGIN_IN_PROGRESS }));
    }

    checkUsername() {
        if (this.m_user.length === 0) return;
        if (this.m_mode === "CREATE_ACCOUNT") {
            if (!validateEmail(this.m_user)) {
                return this.toastr.error(this.translocoService.translate("toast.pleaseProvideValidEmail", {}, this.translocoService.getActiveLang()));
            }
            this.storeSelector.dispatch(actionDynawebsCheckUser({ user: this.fixUserCase(this.m_user) }));
        }
    }

    // sample of utils-decorators
    // @retry({retries: 1, delay: 1})
    onLoginAmazonPopup(e) {
        if (!this.m_mode) this.m_mode = "CREATE_ACCOUNT";
        if (this.m_modeUrlParam === "CHECKOUT") this.m_mode = "CHECKOUT";
        const newWin = window.open(`${this.appSettings.globalService}/AmazonLogin/${this.m_mode}`, "_blank", "width=640,height=480,location=0");
        if (!newWin || newWin.closed || typeof newWin.closed === "undefined") {
            this.toastr.error(this.translocoService.translate("toast.problemLoadingAdnet", {}, this.translocoService.getActiveLang()));
        }
        return false;
    }

    signInAutoLogin(queryParams) {
        /**
         * go to: http://localhost:4200/login?autologineyJ1c2VyIjoiQUEgQ0NhYUFhYSIsInJlc2VsbGVySWQiOjMwMDc2MiwiYnVzaW5lc3NJZCI6NTM4NDI0LCJwYXNzd29yZCI6IjEyMyIsInNlZWQiOjAuNjI3NTU2MjY5MDcyNTczNn0
         * to create your own Base64 auto login: {"user": "AA CCaaAaa", "resellerId": 300762, "businessId": 538424, "password": "xxx" }
         **/
        const c = base64ToJson(queryParams.autologin);
        this.m_user = this.fixUserCase(c.user);
        this.m_pass = c.password;
    }

    signInWithAmazon(id) {
        if (id === "ERROR") {
            this.unAnimateLogin();
            return this.toastr.error("problem with amazon login");
        }
        try {
            this.animateLogin();
            console.log("Amazon rx token " + id);
            const amazonData = JSON.parse(atob(`${id}`));
            this.toastr.info("welcome back " + amazonData.access.email);
            const i_socialUser: SocialUser = new SocialUser();
            i_socialUser.idToken = amazonData;
            i_socialUser.provider = "AMAZON";
            i_socialUser.id = amazonData.access.user_id;
            i_socialUser.email = amazonData.access.email;
            i_socialUser.name = amazonData.access.name;
            i_socialUser.photoUrl = "http://www.www.jpg";
            i_socialUser.firstName = amazonData.access.name.split(" ")[0];
            i_socialUser.lastName = amazonData.access.name.split(" ")[amazonData.access.name.length - 1];
            this.verifyToken(i_socialUser);
        } catch (e) {
            console.log("Problem login with Amazon " + e);
            this.unAnimateLogin();
            return this.toastr.error(this.translocoService.translate("toast.problemLoginWithAmazon", {}, this.translocoService.getActiveLang()));
        }
    }

    signInWithBio(event) {
        // import FingerprintJS from '@fingerprintjs/fingerprintjs-pro'
        // FingerprintJS.load({ token: '0x764382AdCHFdD5262ad3333fecH' })
        //     .then(fp => fp.get())
        //     .then(result => this.createNewAccount(result.visitorId))
        return this.toastr.error(this.translocoService.translate("toast.bioNotDetected2", {}, this.translocoService.getActiveLang()));
    }

    onPrivatesCheckboxChanged(type: "privateServer" | "ldapServer", value: boolean) {
        if (type === "privateServer") {
            this.privateServer = value ? "https://example.com" : "";
            this.onUpdatePrivatesStore("privateServer", this.privateServer);
        } else {
            this.ldapServer = value ? "ldap://ldap.forumsys.com:example.com" : "";
            this.onUpdatePrivatesStore("ldapServer", this.ldapServer);
        }
    }

    onUpdatePrivatesStore(type, i_url) {
        return this.localStoreService.setStorageValConfig(type, i_url);
    }

    onToggleDevServerPort(checked: boolean) {
        this.useDevServerPort = checked;
        const val = convertBooleanToNumbers(checked, true);
        this.localStoreService.setStorageValConfig('useDevServerPort', val);
    }

    createAccountWithPrivates() {
        return this.toastr.error(this.translocoService.translate("general.inDevelopment", {}, this.translocoService.getActiveLang()));
    }

    checkIfSigningPrivateServer(): boolean {
        const appData = _.cloneDeep(this.appSettings);
        if (this.privateServer.length < 10) {
            /** reset back to default **/
            appData.masterServer = DEFAULT_SERVER;
            appData.protocol = DEFAULT_PROTOCOL;
            appData.privateServer = false;
            this.storeSelector.dispatch(actionAppSettings({ appData }));
            return false;
        } else {
            /** set to private server **/
            const vals = this.privateServer.split("://");
            const protocol = `${vals[0]}://`;
            appData.masterServer = vals[1];
            appData.protocol = protocol as any;
            appData.privateServer = true;
            this.storeSelector.dispatch(actionAppSettings({ appData }));
            return true;
        }
    }

    checkIfSigningLdapServer(): boolean {
        if (this.ldapServer.length < 10) return false;
        const d = this.ldapServer.split(":");
        if (d.length !== 3) {
            this.toastr.info(this.translocoService.translate("account.ldapWrongFormat", {}, this.translocoService.getActiveLang()));
            this.unAnimateLogin();
            return true;
        }
        const ldapAddress = d.slice(0, 2).join(":");
        const ldapDomainController = d[2];
        this.toastr.info(this.translocoService.translate("account.authWithLdap", {}, this.translocoService.getActiveLang()));
        this.storeSelector.dispatch(actionAccountCommandsRequest(
            {
                accountRequest: {
                    serverCall: "LDAP_AUTH",
                    verifyAccount: {
                        userName: this.fixUserCase(this.m_user),
                        password: this.m_pass,
                        ldapAddress,
                        ldapDomainController,
                    },
                },
            },
        ));
        return true;
    }

    setupWithPrivates() {
        const dialogRef = this.dialog.open(this.privatesModal, {
            width: "600px",
            height: "370px",
        });
    }

    backToLogin() {
        this.selectedLoginMode = "loginWithEmail";
        this.disabledLoginInputs = false;
        this.m_mode = null;
    }

    signInWithFB(): any {
        // if (!this.isFullFeatures) {
        //   return this.toastr.error(this.translocoService.translate('toast.notSuppYet', {}, this.translocoService.getActiveLang()));
        // }
        this.animateLogin();
        try {
            this.authUserService.getSocialAuthService().signIn(FacebookLoginProvider.PROVIDER_ID).then(socialUser => {
                // socialUser.linkedIn =
                this.verifyToken(socialUser);
            }, (err) => {
                this.unAnimateLogin();
            });
        } catch (e) {
            alert("social module not loaded " + e);
            this.unAnimateLogin();
        }
    }

    signInWithGoogle(): void {
        // this.animateLogin();
        // try {
        //     const authSocial = this.authUserService.getSocialAuthService();
        //     authSocial.signIn(GoogleLoginProvider.PROVIDER_ID).then(socialUser => {
        //         this.verifyToken(socialUser);
        //     }, (err) => {
        //         console.error('problem loading google login module ' + err);
        //         this.unAnimateLogin();
        //     });
        //
        // } catch (e) {
        //     alert('social module not loaded ' + e);
        //     this.unAnimateLogin();
        // }

    }

    createNewAccountSignStudioOnly() {
        this.localStoreService.setStorageValConfig("socialUserPendingStudioType", EnumStudioType.SIGN_STUDIO);
        this.router.navigateByUrl(`/getstarted/template`);
    }

    createNewAccount(e) {
        e.preventDefault();
        this.socialSignOut();
        this.createNewAccountSignStudioOnly();

        // if (this.m_mode) {
        //     this.router.navigate([`/getstarted/pick/${this.m_mode}`]);
        // } else {
        //     this.router.navigate(['/getstarted/pick']);
        // }
    }

    socialSignOut(): void {
        this.authUserService.socialSignOut();
    }

    verifyToken(i_socialUser: SocialUser) {
        this.storeSelector.dispatch(actionAccountSocialLoginRequest({ payload: i_socialUser }));
    }

    get username(): AbstractControl {
        return this.form.get("username");
    }

    get password(): AbstractControl {
        return this.form.get("password");
    }

    passFocus(event) {
        try {
            this.userPass.nativeElement.focus();
        } catch (e) {
        }
    }

    passFocusSecondPass() {
        try {
            this.userPass2.nativeElement.focus();
        } catch (e) {
        }
    }

    navigateToParam(e, v) {
        e.stopImmediatePropagation();
        e.preventDefault();
        this.router.navigateByUrl(`${v}`);
    }

    messageInvalidCharChosen(e) {
        switch (e.restriction) {
            case "login": {
                this.toastr.error(this.translocoService.translate("toast.charNotAllowed", {}, this.translocoService.getActiveLang()) + ` <br/> A-Z 0-9 @ _ .`);
                break;
            }
            case "password": {
                this.toastr.error(this.translocoService.translate("toast.pleaseAvoidChar", {}, this.translocoService.getActiveLang()) + avoidPassCharacters());
                break;
            }
            default: {
                this.toastr.error(this.translocoService.translate("toast.charNotAllowed", {}, this.translocoService.getActiveLang()) + ` ...`);
            }
        }
    }

    override destroy() {
        this.styleService.removeStyle("loginStyle");
        // this.m_loginSubscriber.unsubscribe();
    }
}
